import { ContainerGrid } from '~/components/layout/PageStructure';
import React from 'react';
import { Redirect, useParams as useUrl } from 'react-router-dom';
import { getImageSet, htmlToText } from '~/utils/helpers';
import ProductDetails from '~/components/product/ProductDetails';
import ProductStructuredData from '~/components/meta/structured-data/ProductStructuredData';
import RelatedProducts from '~/components/product/RelatedProducts';
import SEO from '~/components/meta/SEO';
import { useSiteContext } from '~/context/SiteContext';
import useParams from '~/hooks/useParams';
import { useProduct } from '~/hooks/useProduct';
import { ProductDetailLoader } from '~/components/ui/organisms/ProductDetailLoader';

const Product = () => {
  const {
    theme: { productPageRelatedProducts },
    globals: { shopInfo },
  } = useSiteContext();
  const { slug, id } = useUrl<{ slug: string; id: string }>();
  const { getParam } = useParams();
  const linkedVariantId = getParam('variant');
  const splitAttr = getParam('split');
  const isFromTikTok = getParam('source-tiktok') !== null;

  // ID will be used before slug, if it is present
  const { response, isResolved } = useProduct({
    includeUnpublished: isFromTikTok,
    id,
    slug,
  });

  if (isResolved && !response.product) {
    return <Redirect to="/404" />;
  }

  const product: any = response?.product || { name: '' };
  const { name, storeDescription, relatedProducts } = product;
  const images = getImageSet(response?.product);
  const showRelatedProducts = relatedProducts?.length > 0;

  return (
    <ProductDetailLoader ready={isResolved}>
      <SEO
        title={name}
        description={htmlToText(storeDescription)}
        image={images[0]?.url}
      />

      <ContainerGrid className="mb-8 mt-7">
        <ProductDetails
          product={product}
          linkedVariantId={linkedVariantId}
          splitAttr={splitAttr}
          isLive={false}
        />
      </ContainerGrid>

      {productPageRelatedProducts && showRelatedProducts && (
        <RelatedProducts
          className="col-span-full"
          data={{
            title: 'Customers also bought',
            products: relatedProducts,
          }}
        />
      )}

      <ProductStructuredData
        product={response?.product}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        meta={{ shopName: shopInfo.name }}
        location={window.location}
      />
    </ProductDetailLoader>
  );
};

export default Product;
